import React from "react";
import { Notification } from "pepsico-ds";
function LogoutPage() {
  return (
    <div style={{ marginTop: "20px", marginLeft: "20px" }}>
      <Notification text={"You have been Logged Out!!"} type="info" />
      <div>Please login again to continue. <span className="link" onClick={() => window.location.href = '/login'}>Click here </span>  to login.</div>
    </div>
  );
}

export default LogoutPage;
